export default __webpack_public_path__ + "static/media/Blue_Rhapsody_KH.09b7af5c.png";